import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGINATION_DEFAULT } from 'utils/constants';
import { SCREEN_TYPE, TRACKING_TYPE } from 'utils/enums';

const initialState: ITrackingState = {
    screenMode: SCREEN_TYPE.list,
    trackingType: TRACKING_TYPE.TRACKING_FORWARD,
    paginateTrackingForward: PAGINATION_DEFAULT,
    paginateTrackingBack: PAGINATION_DEFAULT,
    keywordSearchTrackingForward: [],
    keywordSearchTrackingBack: [],
    selectedTrackingForwardItems: [],
    selectedTrackingBackItems: [],
    sortTrackingForward: '',
    sortTrackingBack: '',
    searchConditionTrackingBack: undefined,
    searchConditionTrackingForward: undefined,
    paramsTrackingDetails: [
        {
            level: 0,
            parent_container_id: undefined,
            tracking_id: undefined,
            manifest_id: undefined,
            generic_id: undefined,
            container_ids: undefined,
            parent_task_id: undefined,
            tracking_id_search: undefined,
        },
    ],
};

export const trackingSlice = createSlice({
    name: 'trackingSlice',
    initialState,
    reducers: {
        // <> STATE <>
        init: () => initialState,

        // set level tracking forward params search
        setLevelTrackingDetails: (state, action: PayloadAction<IParamsTrackingDetails[]>) => {
            state.paramsTrackingDetails = action.payload;
        },

        // set mode screen: LIST <> DETAIL <> REGISTER (in task page)
        setMode: (state, action: PayloadAction<SCREEN_TYPE>) => {
            state.screenMode = action.payload;
        },
        // set mode screen: LIST <> DETAIL <> REGISTER (in task page)
        setTrackingType: (state, action: PayloadAction<TRACKING_TYPE>) => {
            state.trackingType = action.payload;
        },
        // set search conditions
        setConditionTrackingForward: (
            state,
            action: PayloadAction<ITrackingForwardSearch | undefined>,
        ) => {
            state.searchConditionTrackingForward = action.payload;
        },
        setConditionTrackingBack: (
            state,
            action: PayloadAction<ITrackingBackSearch | undefined>,
        ) => {
            state.searchConditionTrackingBack = action.payload;
        },
        // set keywords search conditions
        setKeywordSearchTrackingForward: (state, action: PayloadAction<string[]>) => {
            state.keywordSearchTrackingForward = action.payload;
        },
        setKeywordSearchTrackingBack: (state, action: PayloadAction<string[]>) => {
            state.keywordSearchTrackingBack = action.payload;
        },
        // set sort column like "column_name:asc|desc"
        setSortTrackingForward: (state, action: PayloadAction<string>) => {
            state.sortTrackingForward = action.payload;
        },
        setSortTrackingBack: (state, action: PayloadAction<string>) => {
            state.sortTrackingBack = action.payload;
        },
        // set pagination meta data
        setPaginateTrackingForward: (state, action: PayloadAction<Pagination>) => {
            state.paginateTrackingForward = action.payload;
        },
        setPaginateTrackingBack: (state, action: PayloadAction<Pagination>) => {
            state.paginateTrackingBack = action.payload;
        },
        // set selected items
        setSelectedItemsTrackingForward: (state, action: PayloadAction<string[]>) => {
            state.selectedTrackingForwardItems = action.payload;
        },
        setSelectedItemsTrackingBack: (state, action: PayloadAction<string[]>) => {
            state.selectedTrackingBackItems = action.payload;
        },
    },
});

export const {
    setMode,
    setTrackingType,
    setConditionTrackingBack,
    setConditionTrackingForward,
    setKeywordSearchTrackingBack,
    setKeywordSearchTrackingForward,
    setPaginateTrackingBack,
    setPaginateTrackingForward,
    setSelectedItemsTrackingBack,
    setSelectedItemsTrackingForward,
    setSortTrackingBack,
    setSortTrackingForward,
    init,
    setLevelTrackingDetails,
} = trackingSlice.actions;

export default trackingSlice.reducer;
